// Nav — static helpers only. Live data comes from the /api/live singleton.

// Canonical ticker list (what a valid /:ticker URL can be)
export const LISTED_TICKERS = [
  "NVDA", "AAPL", "GOOG", "TSLA", "SPY", "MSTR",
  "GME", "SPCX", "MSFT", "AMZN", "META", "COIN",
];

export const NAMES = {
  NVDA: "NVIDIA CORP TOKEN",
  AAPL: "APPLE INC TOKEN",
  GOOG: "ALPHABET INC TOKEN",
  TSLA: "TESLA INC TOKEN",
  SPY:  "SPDR S&P 500 TOKEN",
  MSTR: "MICROSTRATEGY TOKEN",
  GME:  "GAMESTOP CORP TOKEN",
  SPCX: "SPACE EXPLORATION TOKEN",
  MSFT: "MICROSOFT CORP TOKEN",
  AMZN: "AMAZON.COM INC TOKEN",
  META: "META PLATFORMS TOKEN",
  COIN: "COINBASE GLOBAL TOKEN",
};

export const isListedTicker = (t) =>
  !!t && LISTED_TICKERS.includes(t.toUpperCase());

export const deltaOf = (r) => {
  if (!r || r.pool == null || r.nav == null || r.nav === 0) return null;
  return ((r.pool - r.nav) / r.nav) * 100;
};

// Static demo (kept as fallback for pads until real APIs exist)
export const NEW_PAIRS = [
  { ticker: "PONS",     pad: "pons.trade",  quote: "USDG", curve: 62, score: 78, age: "2h" },
  { ticker: "CASHCAT",  pad: "hood.fun",    quote: "WETH", curve: 34, score: 44, age: "5h" },
  { ticker: "GOLDLEAF", pad: "pools.trade", quote: "NVDA", curve: 88, score: 91, age: "1d" },
  { ticker: "OAKROOT",  pad: "pons.trade",  quote: "USDG", curve: 19, score: 51, age: "3h" },
  { ticker: "FINCH",    pad: "hood.fun",    quote: "USDG", curve: 7,  score: 33, age: "40m" },
  { ticker: "SLATE",    pad: "pools.trade", quote: "ETH",  curve: 71, score: 66, age: "8h" },
  { ticker: "EMBER",    pad: "pons.trade",  quote: "USDG", curve: 55, score: 72, age: "12h" },
];

// Deterministic 32-point ink line for cards/tickets.
export function sparkline(seed, delta) {
  const pts = [];
  let x = 50;
  const d = delta == null ? 0 : delta;
  for (let i = 0; i < 32; i++) {
    const noise = Math.sin(seed * 13.37 + i * 1.7) * 1.1;
    x += noise + (d > 0 ? 0.28 : d < 0 ? -0.28 : 0);
    pts.push(x);
  }
  return pts;
}
